export default function (client) {
    return {
        getList: async function () {
            return await client.get('/geo/city');
        }
    }
}